import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { DASHBOARD_PATH } from "utils/constants/paths";

const Dashboard = Loadable(React.lazy(() => import("./View")));

export const DashboardRoute: IRouteItem = {
  path: DASHBOARD_PATH,
  iconName: "HomeTrendUp",
  element: React.createElement(Dashboard),
  name: "Dashboard",
  accessKeys: ["Analyst"],
};
